/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PathwayUser } from '../models/PathwayUser';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UsersService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Set cloudfront cookies for cdn
     * Set cloudfront cookies for cdn.
     * @returns any Ok
     * @throws ApiError
     */
    public getCdnAuth(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/cdn-auth',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Find users assigned to locations
     * Find users assigned to locations.
     * @returns PathwayUser Ok
     * @throws ApiError
     */
    public getUsersForLocations({
        locationNumbers,
    }: {
        locationNumbers: Array<string>,
    }): CancelablePromise<Array<PathwayUser>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users',
            query: {
                'locationNumbers': locationNumbers,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }

}
